import React from 'react'
import ReactDOM from 'react-dom'

type ComponentRegistry = Record<string, React.ComponentType<any>>

export function mountReactComponents(registry: ComponentRegistry) {
  document.querySelectorAll<HTMLElement>('[data-react-component]').forEach((node) => {
    const name = node.dataset.reactComponent
    if (!name) return

    const Component = registry[name]
    if (!Component) {
      console.error(`React component "${name}" is not registered in this entrypoint`)
      return
    }

    const propsNode = document.getElementById(`${node.id}-props`)
    const props = propsNode ? JSON.parse(propsNode.textContent || '{}') : {}

    ReactDOM.render(React.createElement(Component, props), node)
  })
}
